<template>
    <detail-form
        v-model="treasureForm">
        <template v-slot:content="{ form }">
            <detail-form-item
                required
                cols="6"
                type="text"
                v-model="form.name"
                :label="$t('treasureHunt.detail.name')"/>
            <detail-form-item
                required
                cols="6"
                type="geolocation"
                v-model="form.geolocation"
                :label="$t('treasureHunt.detail.geolocation')"/>
            <detail-form-item
                required
                cols="4"
                type="number"
                v-model="form.scale[0]"
                label="scaleX"/>
            <detail-form-item
                required
                cols="4"
                type="number"
                v-model="form.scale[1]"
                label="scaleY"/>
            <detail-form-item
                required
                cols="4"
                type="number"
                v-model="form.scale[2]"
                label="scaleZ"/>
        </template>
    </detail-form>
</template>

<script>
import DetailForm from '@/components/forms/DetailForm'
import DetailFormItem from '@/components/forms/DetailFormItem'

export default {
    name: 'TreasureDetailView',

    model: {
        prop: 'treasure',
        event: 'input'
    },

    props: {
        treasure: {
            type: Object,
            default: () => null
        }
    },

    components: {
        DetailForm,
        DetailFormItem
    },

    computed: {
        treasureForm: {
            get () {
                if (this.treasure && !this.treasure.geolocation) {
                    this.$set(this.treasure, 'geolocation', {
                        latitude: this.treasure.latitude,
                        longitude: this.treasure.longitude
                    })
                }

                if (this.treasure && !this.treasure.scale) {
                    const scale = this.treasure.arScale?.map(scale => parseFloat(scale?.trim()))
                    this.$set(this.treasure, 'scale', scale)
                }
                return this.treasure
            },

            set (value) {
                this.$emit('input', value)
            }
        }
    },

    methods: {
        async save () {
            const { geolocation, scale, ...updateForm } = this.treasureForm
            updateForm.latitude = geolocation.latitude
            updateForm.longitude = geolocation.longitude
            updateForm.arScale = [`${scale[0]}`, `${scale[1]}`, `${scale[2]}`]
            await this.$store.dispatch('treasureHunt/updateTreasure', updateForm)
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
